import { footerBranding } from "../config/branding";

export default function AppFooter({ className = "" }) {
  if (!footerBranding.enabled) return null;

  return (
    <footer className={`border-t border-zinc-200 py-5 ${className}`}>
      <div className="max-w-7xl mx-auto px-4 md:px-8 text-xs text-zinc-500">
        <span>
          Developed by{" "}
          <a
            href={footerBranding.agencyUrl}
            target="_blank"
            rel="noreferrer"
            className="font-semibold text-zinc-700 hover:text-[#0033CC]"
          >
            {footerBranding.agencyName}
          </a>
        </span>
      </div>
    </footer>
  );
}
